import Helper from '@ember/component/helper';

class AddBodyEventListenerHelper extends Helper {
  cleanup = null;

  compute([type, listener, options]) {
    this.cleanup?.();
    document.body.addEventListener(type, listener, options);

    this.cleanup = () => {
      document.body.removeEventListener(type, listener);
    };
  }

  willDestroy() {
    super.willDestroy();
    this.cleanup?.();
  }
}

export default AddBodyEventListenerHelper;
